export default __webpack_public_path__ + "static/media/youtube-png.5b743fc5.png";